import type {Auth, Department, Exemplar, RichDocument} from 'typings/portaro.be.types';
import {identifiedValuesEquals} from 'shared/utils/custom-utils';
import ExemplarFilter from './exemplar-filter';

export type ExemplarsType = 'bindings' | 'exemplars';

export interface ExemplarsPair {
    building: Department;
    exemplars: Exemplar[];
}

export default class ExemplarList {

    public exemplarFilter: ExemplarFilter;
    public type: ExemplarsType;
    public divisions: ExemplarsPair[];
    public divisionsLength: number;
    public filteredExemplars: Exemplar[];

    constructor(private document: RichDocument, public exemplars: Exemplar[], private listView, private currentAuth: Auth) {
        this.exemplarFilter = new ExemplarFilter(this.listView.showableExemplarStatuses);
        this.filteredExemplars = this.getFilteredExemplars();
        this.type = document.periodical ? 'bindings' : 'exemplars';
        this.divisions = this.buildDivisions();
        this.divisionsLength = this.divisions ? Object.keys(this.divisions).length : 1;
    }

    public canCreateAny(): boolean {
        return this.listView.canCreateAny;
    }

    public canCreateWithDepartment(department: Department): boolean {
        return this.listView.creatingPermittedDeps.some((permittedDepartment) => department.id === permittedDepartment.id);
    }

    private buildDivisions() {
        if (!this.listView.exemplarTabsByBuildingsEnabled) {
            return [{
                building: null,
                exemplars: this.filteredExemplars
            }];
        }

        const pairs = [];

        if (this.listView.forceVisibleDeps) {
            this.listView.forceVisibleDeps.forEach((department) => this.getPairEventuallyCreating(department, pairs));
        }

        this.currentAuth.editableDepartments.forEach((department) => this.getPairEventuallyCreating(department, pairs));

        this.filteredExemplars
            .forEach((exemplar) => this.getPairEventuallyCreating(exemplar.department, pairs).exemplars.push(exemplar));

        return pairs;
    }

    private getPairEventuallyCreating(building: Department, pairs: ExemplarsPair[]): ExemplarsPair {
        for (const pair of pairs) {
            if (identifiedValuesEquals(pair.building, building)) {
                return pair;
            }
        }

        const newPair: ExemplarsPair = {
            building,
            exemplars: []
        };

        pairs.push(newPair);

        return newPair;
    }

    private getFilteredExemplars() {
        const forUserExemplarFilter = this.exemplarFilter.forUser(this.currentAuth);
        return this.exemplars.filter(forUserExemplarFilter);
    }

    public get empty(): boolean {
        return this.filteredExemplars.length === 0;
    }
}